<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div v-if="visible" class="modal-overlay link-warning-overlay" @click.self="close">
        <div class="custom-modal link-warning-modal">
        <div class="modal-header">
          <h3>
            <i class="fa-solid fa-shield-halved security-icon"></i>
            站外安全跳转提示
          </h3>
          <button class="close-btn" @click="close">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        
        <div class="modal-body">
          <div class="warning-info">
            <div class="warning-badge">
              <i class="fa-solid fa-circle-exclamation"></i>
              安全警告
            </div>
            <p class="warning-text">
              您即将离开云语匀雨，前往第三方站点。我们无法确保外部站点的安全性，请注意防范钓鱼网站，保护您的个人敏感信息及财产安全！
            </p>
          </div>

          <div class="url-card">
            <div class="url-card-title">目标网址</div>
            <div class="url-card-content">
              <span class="target-url">{{ url }}</span>
              <button 
                class="copy-link-btn" 
                :class="{ 'copy-success': copySuccess }"
                @click="copyUrl"
                title="复制链接"
              >
                <i :class="copySuccess ? 'fa-solid fa-check' : 'fa-regular fa-copy'"></i>
                <span>{{ copySuccess ? '已复制' : '复制网址' }}</span>
              </button>
            </div>
          </div>
          <div class="warning-tip">微信/飞书内置浏览器如无法直接访问，可复制网址并在外部浏览器中打开。</div>
        </div>
        
        <div class="modal-footer">
          <button class="cancel-btn" @click="close">留在本站</button>
          <button class="confirm-btn" @click="confirm">继续访问</button>
        </div>
      </div>
    </div>
  </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'LinkWarningModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    }
  },
  emits: ['update:visible', 'confirm'],
  data() {
    return {
      copySuccess: false
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
    },
    confirm() {
      this.$emit('confirm', this.url);
    },
    copyUrl() {
      if (!this.url) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.url).then(() => {
          this.showCopyFeedback();
        }).catch(() => {
          this.fallbackCopy();
        });
      } else {
        this.fallbackCopy();
      }
    },
    fallbackCopy() {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = this.url;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.showCopyFeedback();
      } catch (err) {
        this.$message?.error('复制失败，请手动选择复制');
      }
    },
    showCopyFeedback() {
      this.copySuccess = true;
      setTimeout(() => {
        this.copySuccess = false;
      }, 2000);
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-overlay,
.link-warning-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-security-modal, 100000) !important;
}

.custom-modal {
  background: #ffffff;
  border-radius: 18px;
  width: 92%;
  max-width: 480px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 85vh;
  border: 1px solid rgba(255, 255, 255, 0.6);
  animation: modalScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes modalScaleIn {
  from {
    transform: scale(0.92) translateY(12px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.modal-header {
  padding: 18px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-family: '猫啃网糖圆体', sans-serif;
  font-size: 1.25em;
  color: #1f2937;
  display: flex;
  align-items: center;
  gap: 8px;
}

.security-icon {
  color: #3b82f6;
  font-size: 1.1em;
}

.close-btn {
  background: rgba(0, 0, 0, 0.03);
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s;
}

.close-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.modal-body {
  padding: 24px;
  flex: 1;
  overflow-y: auto;
}

.warning-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.warning-badge {
  align-self: flex-start;
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
  font-family: '爱点风雅黑', sans-serif;
  font-size: 0.85em;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.warning-text {
  color: #4b5563;
  font-family: '爱点风雅黑', sans-serif;
  font-size: 0.95em;
  line-height: 1.6;
  margin: 0;
}

.url-card {
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
}

.url-card-title {
  font-family: '爱点风雅黑', sans-serif;
  font-size: 0.85em;
  color: #9ca3af;
  margin-bottom: 8px;
  font-weight: bold;
}

.url-card-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.target-url {
  font-family: 'Consolas', 'Courier New', monospace;
  font-size: 0.9em;
  color: #3b82f6;
  word-break: break-all;
  max-height: 72px;
  overflow-y: auto;
  line-height: 1.5;
  background: rgba(59, 130, 246, 0.04);
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px dashed rgba(59, 130, 246, 0.15);
}

.copy-link-btn {
  align-self: flex-end;
  background: #ffffff;
  border: 1px solid #d1d5db;
  color: #4b5563;
  font-family: '爱点风雅黑', sans-serif;
  font-size: 0.85em;
  padding: 6px 14px;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.25s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
}

.copy-link-btn:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
  color: #1f2937;
}

.copy-link-btn.copy-success {
  background: rgba(16, 185, 129, 0.1) !important;
  border-color: rgba(16, 185, 129, 0.2) !important;
  color: #059669 !important;
}

.warning-tip {
  font-family: '爱点风雅黑', sans-serif;
  font-size: 0.8em;
  color: #9ca3af;
  line-height: 1.4;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn {
  padding: 9px 22px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #4b5563;
  border-radius: 24px;
  cursor: pointer;
  font-family: '爱点风雅黑', sans-serif;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.25s;
}

.cancel-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #1f2937;
}

.confirm-btn {
  padding: 9px 24px;
  border: none;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border-radius: 24px;
  cursor: pointer;
  font-family: '爱点风雅黑', sans-serif;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.25s;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.25);
}

.confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.35);
}

.confirm-btn:active {
  transform: translateY(0);
}

/* Dark Theme Support */
.dark-theme .custom-modal {
  background: #1f2937;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);
}

.dark-theme .modal-header {
  border-bottom-color: rgba(255, 255, 255, 0.06);
}

.dark-theme .modal-header h3 {
  color: #f9fafb;
}

.dark-theme .close-btn {
  background: rgba(255, 255, 255, 0.05);
  color: #9ca3af;
}

.dark-theme .close-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
}

.dark-theme .warning-text {
  color: #d1d5db;
}

.dark-theme .url-card {
  background: #111827;
  border-color: #374151;
}

.dark-theme .target-url {
  background: rgba(59, 130, 246, 0.06);
  border-color: rgba(59, 130, 246, 0.25);
  color: #60a5fa;
}

.dark-theme .copy-link-btn {
  background: #374151;
  border-color: #4b5563;
  color: #d1d5db;
}

.dark-theme .copy-link-btn:hover {
  background: #4b5563;
  color: #ffffff;
}

.dark-theme .copy-link-btn.copy-success {
  background: rgba(16, 185, 129, 0.15) !important;
  border-color: rgba(16, 185, 129, 0.3) !important;
  color: #34d399 !important;
}

.dark-theme .modal-footer {
  border-top-color: rgba(255, 255, 255, 0.06);
}

.dark-theme .cancel-btn {
  background: #374151;
  border-color: #4b5563;
  color: #d1d5db;
}

.dark-theme .cancel-btn:hover {
  background: #4b5563;
  color: #ffffff;
}

/* Modal Fade Animation */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .custom-modal {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-fade-leave-active .custom-modal {
  transition: transform 0.25s ease-in;
}

.modal-fade-enter-from .custom-modal {
  transform: scale(0.92) translateY(12px);
}

.modal-fade-leave-to .custom-modal {
  transform: scale(0.95) translateY(10px);
}

/* Responsive & Mobile Drawer Layout */
@media (max-width: 480px) {
  .custom-modal {
    width: 100%;
    border-radius: 24px 24px 0 0;
    position: absolute;
    bottom: 0;
    margin: 0;
    max-width: none;
    max-height: 85vh;
    border-left: none;
    border-right: none;
    border-bottom: none;
  }
  
  .modal-overlay,
  .link-warning-overlay {
    align-items: flex-end;
  }
  
  .modal-fade-enter-from .custom-modal,
  .modal-fade-leave-to .custom-modal {
    transform: translateY(100%) scale(1);
  }
}
</style>
